<template>
  <div class="manage-person">
    <div class="m-p-box">
      <router-link
        v-if="!$isDingDing"
        :to="{path:'/organization/invite', query: $route.query}"
        class="ant-btn ant-btn-primary"
      >
        {{ $t('message["1437"]') }}
      </router-link>
      <span v-if="$isDingDing">
        <i class="qwdd-icon iconfont iconicon-test83" />
        <strong>已绑定：{{ companyName }}</strong>
        <a
          href="javascript:;"
          class="dt-step-btn"
          @click="refreshData"
        >钉钉同步</a>
      </span>
      <template v-if="bindType && !$isDingDing">
        <a-button
          v-if="!strutctureStatus"
          @click="changeStructure"
        >
          {{ typeTxt }}{{ $t('message["1676"]') }}
        </a-button>
        <template v-else-if="strutctureStatus === 1">
          <a-button
            @click="refreshData"
          >
            {{ $t('message["382"]') }}
          </a-button>
          <span class="dd-refresh-tip">{{ curMapTxt[0] }}{{ typeTxt }}{{ curMapTxt[1] }}</span>
        </template>
      </template>
    </div>
    <div class="person-box clearfix">
      <template>
        <p-list v-if="!strutctureStatus" />
        <p-list-tree v-else-if="strutctureStatus === 1" />
      </template>
      <p-info />
    </div>
    <dd-qw-load-tip
      ref="ddLoadTip"
      :txt="typeTxt"
      @triggerMethod="setStructure"
    />
  </div>
</template>
<script>
import PList from '@/components/pc/organization/person/PList'
import PListTree from '@/components/pc/organization/person/PListTree'
import PInfo from '@/components/pc/organization/person/PInfo'
import DdQwLoadTip from '@/components/pc/organization/person/DdQwLoadTip'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    PList,
    PInfo,
    DdQwLoadTip,
    PListTree
  },
  props: {
    // queryData: {
    //   type: Object,
    //   default () {
    //     return {}
    //   }
    // }
  },
  data () {
    return {
      // current: '1'
      companyName: ''
    }
  },
  computed: {
    ...mapState('organization/person', {
      storeCurrent: 'current'
    }),
    ...mapState('organization/person', ['datas', 'bindType', 'strutctureStatus']),
    // current: {
    //   get () {
    //     return this.storeCurrent
    //   },
    //   set (value) {
    //     return this.setCurrentIndex(value)
    //   }
    // },
    cid () {
      return this.$route.query.cid
    },
    typeTxt () {
      let txt = ''
      const { bindType } = this
      if (bindType === 2) {
        txt = this.$t('message["718"]')
      } else if (bindType === 3) {
        txt = this.$t('message["238"]')
      }
      return txt
    },
    curMapTxt () {
      return this.$t('message["182"]').split('|')
    }
  },
  async created () {
    this.setCId(this.cid)
    const chain = await this.getOrgType()
    chain.params({ cid: this.cid })
      .onSuccess(raw => {
        const type = raw.dingtalk_structure_status
        this.companyName = raw.corp_name
        if (type === 2) {
          // this.setStrutctureStatus(2)
          this.$refs.ddLoadTip.changeLimitDialog(true)
          let timer = ''
          timer = setInterval(async () => {
            const chain2 = await this.getOrgType({ cid: this.cid })
            chain2.params({ cid: this.cid })
              .onSuccess(raw2 => {
                if (raw2.dingtalk_structure_status !== 2) {
                  this.setStrutctureStatus(4)
                  clearInterval(timer)
                  location.reload()
                }
              })
              .fetch()
          }, 5000)
        } else {
          this.fetchCurData(type)
        }
      })
      .fetch()
    // this.$refs.ddLoadTip.changeLimitDialog(true)
  },
  methods: {
    ...mapActions('organization/person', ['fetchCurrentDatas', 'fetchItemInfoDatas', 'getOrgType', 'getStructureList', 'setStructureStatus2']),
    ...mapMutations('organization/person', ['setCId', 'setStrutctureStatus']),
    async fetchCurData (type) {
      if (type === 0) {
        const chain = await this.fetchCurrentDatas({ cid: this.cid })
        chain.params({ cid: this.cid, isall: 1 })
          .fetch()
      } else if (type === 1) {
        const chain = await this.getStructureList({ cid: this.cid })
        chain.fetch()
      }
    },
    async changeStructure () {
      this.$refs.ddLoadTip.changeLimitDialog(true)
    },
    async setStructure () {
      const chain = await this.setStructureStatus2({ cid: this.cid })
      chain.onSuccess(raw => {
        let timer = ''
        if (raw.dingtalk_structure_status === 2) {
          timer = setInterval(async () => {
            const chain2 = await this.getOrgType({ cid: this.cid })
            chain2.params({ cid: this.cid })
              .onSuccess(raw2 => {
                if (raw2.dingtalk_structure_status !== 2) {
                  clearInterval(timer)
                }
              })
              .fetch()
          }, 5000)
        } else {
          clearInterval(timer)
        }
      })
        .fetch()
    },
    async refreshData () {
      // this.setCId(this.cid)
      this.setStrutctureStatus(2)
      this.$refs.ddLoadTip.changeLimitDialog(true)
      await this.setStructure()
    }
  }
}
</script>
<style lang="scss" scoped>
  .manage-person {
    .list-tab {
      padding: 8px 0 24px;
    }

    .person-box {
      border: 1px solid #ebebeb;
      border-radius: 4px;
      margin-bottom: 24px;
      width: 1198px;
    }
    .m-p-box {
      padding: 8px 0 24px;
       .qwdd-icon {
         font-size: 32px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 10px;
          color:#4494F0;
        }
        .dt-step-btn {
          margin-left: 10px;
        }
      .dd-refresh-tip {
        color: #999;
      }
    }
  }
</style>
